var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions-list-item"},[_vm._t("default",[_c('h3',[_vm._t("question",[_vm._v(_vm._s(_vm.question))])],2),_c('p',{domProps:{"innerHTML":_vm._s(_vm.answer)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }